import {combineReducers} from 'redux';
import LoginLogout from './LoginLogout';
import GeneralBucket from './GeneralBucket';
import HomeBucket from './HomeBucket'; 
import KnowledgeCenterBucket from './KnowledgeCenterBucket';
import WebSocketBucket from './WebSocketBucket';
import ModalPopupBucket from './ModalPopupBucket';
import NotificationBucket from './NotificationBucket';
import RecSessionsBucket from './RecSessionsBucket';
import TopicBucket from './TopicDataBucket';

const rootReducer = combineReducers({
    LoginLogout,
    GeneralBucket,
    HomeBucket,
    KnowledgeCenterBucket,
    WebSocketBucket,
    ModalPopupBucket,
    NotificationBucket,
    RecSessionsBucket,
    TopicBucket
})

export default rootReducer